package scenes.test

import com.soywiz.korge.input.*
import com.soywiz.korge.scene.*
import com.soywiz.korge.ui.*
import com.soywiz.korge.view.*
import com.soywiz.korim.color.*
import utils.*

class Box2dScene : Scene() {
    override suspend fun SContainer.sceneInit() {

    }

    override suspend fun SContainer.sceneMain() {

        solidRect(GameDimensions.V_WIDTH, GameDimensions.V_HEIGHT, Colors.DARKBLUE)

        val text1 = text("B1:")
            .position(10, 5)

        val text2 = text("B2:")
            .position(150, 5)

        val text3 = text("B3:")
            .position(300, 5)
//        val buttonTexts = (0 until 2).map {
//            text("-").position(5, 20 * (it + 1) + 5)
//        }
//
//        val debugInfo = text("-")
//            .position(GameDimensions.V_WIDTH / 2.0, 5.0)

//        UiButtons()

        SingleTouchButtons()

        touchButtons()

//        container {
//            addTouchGamepad(
//                GameDimensions.V_WIDTH.toDouble(), GameDimensions.V_HEIGHT.toDouble(),
//                onStick = { x, y -> text1.setText("Stick: (${x.toStringDecimal(2)}, ${y.toStringDecimal(2)})") },
//                onButton = { button, pressed -> buttonTexts[button].setText("Button: $button, $pressed") },
//                onDebug = { x, y ->
//                    debugInfo.setText("$x , $y")
//                }
//            )
//        }
    }
}

fun Container.touchButtons() {

    val butSize = 100.0

    val margin = butSize + 50
    val butHeight = GameDimensions.V_HEIGHT * 2 / 3.0

    solidRect(butSize, butSize, Colors.RED) {
        position(10.0, butHeight)

        val view = this
        var pressing = false
        var eventId: Int? = null

        touch {
            start {
                if (view.hitTest(it.global) != null &&
                    !pressing &&
                    eventId == null
                ) {
                    println("start RED")
                    pressing = true
                    eventId = it.id
                    alpha(0.5)
                }
            }

            move {
//                println("move RED")
            }

            end {
                if (it.id == eventId) {
                    eventId = null
                    pressing = false
                    println("end RED")
                    alpha(1.0)
                }
            }
        }

        onDown {
            if (pressing) return@onDown
            println("onDown RED")
            pressing = true
            alpha(0.5)
        }

        onUpAnywhere {
            if (!pressing) return@onUpAnywhere
            pressing = false
            println("onUpAnywhere RED")
            alpha(1.0)
        }
    }

    solidRect(butSize, butSize, Colors.GREEN) {
        position(10.0 + margin, butHeight)

        val view = this
        var pressing = false
        var eventId: Int? = null

        touch {
            start {
                if (view.hitTest(it.global) != null &&
                    !pressing &&
                    eventId == null
                ) {
                    println("start GREEN")
                    pressing = true
                    eventId = it.id
                    alpha(0.5)
                }
            }

            move {
//                println("move RED")
            }

            end {
                if (it.id == eventId) {
                    eventId = null
                    pressing = false
                    println("end GREEN")
                    alpha(1.0)
                }
            }
        }

        onDown {
            if (pressing) return@onDown
            println("onDown GREEN")
            pressing = true
            alpha(0.5)
        }

        onUpAnywhere {
            if (!pressing) return@onUpAnywhere
            pressing = false
            println("onUpAnywhere GREEN")
            alpha(1.0)
        }
    }

    solidRect(butSize, butSize, Colors.PURPLE) {
        position(10.0 + margin * 2, butHeight)

        val view = this
        var pressing = false
        var eventId: Int? = null

        touch {
            start {
                if (view.hitTest(it.global) != null &&
                    !pressing &&
                    eventId == null
                ) {
                    println("start PURPLE")
                    pressing = true
                    eventId = it.id
                    alpha(0.5)
                }
            }

            move {
//                println("move RED")
            }

            end {
                if (it.id == eventId) {
                    eventId = null
                    pressing = false
                    println("end PURPLE")
                    alpha(1.0)
                }
            }
        }

        onDown {
            if (pressing) return@onDown
            println("onDown PURPLE")
            pressing = true
            alpha(0.5)
        }

        onUpAnywhere {
            if (!pressing) return@onUpAnywhere
            pressing = false
            println("onUpAnywhere PURPLE")
            alpha(1.0)
        }
    }
}

/**
 * нужно зажать одну кнопку только после этого можно нажать другую
 */
fun Container.SingleTouchButtons() {

    val butSize = 100.0

    val margin = butSize + 50
    val butHeight = GameDimensions.V_HEIGHT  / 3.0

    solidRect(butSize, butSize, Colors.RED) {
        position(10.0, butHeight)

        var pressing = false

        singleTouch {
            start {
                pressing = true
                alpha(0.5)
                println("start RED")
            }

            endAnywhere {
                if (pressing) {
                    pressing = false
                    alpha(1.0)
                }
            }
        }
    }

    solidRect(butSize, butSize, Colors.GREEN) {
        position(10.0 + margin, butHeight)

        var pressing = false

        singleTouch {
            start {
                pressing = true
                alpha(0.5)
                println("start GREEN")
            }

            endAnywhere {
                if (pressing) {
                    pressing = false
                    alpha(1.0)
                }
            }
        }
    }

    solidRect(butSize, butSize, Colors.PURPLE) {
        position(10.0 + margin * 2, butHeight)

        var pressing = false

        singleTouch {
            start {
                pressing = true
                alpha(0.5)
                println("start PURPLE")
            }

            endAnywhere {
                if (pressing) {
                    pressing = false
                    alpha(1.0)
                }
            }
        }
    }
}

fun Container.UiButtons() {
    uiButton(label = "1", height = 100.0) {
        position(10.0, GameDimensions.V_HEIGHT * 2 / 3.0)
        onPress { println("B1 true") }

    }
    uiButton(label = "2", height = 100.0) {
        position(150.0, GameDimensions.V_HEIGHT * 2 / 3.0)
        onPress { println("B2 true") }
    }

    uiButton(label = "3", height = 100.0) {
        position(300.0, GameDimensions.V_HEIGHT * 2 / 3.0)
        onPress { println("B3 true") }
    }
}
